import React from 'react';
import { useParams } from 'react-router-dom';
import { ApolloError, useQuery } from '@apollo/client';
import { FindFormationByTypeIdQuery } from '../../../graphql/generated/graphql';
import { QUERY_FORMATIONS_BY_TYPE } from '../../../graphql/query/formation/queryFormationByType';
import { LoadingLayout } from 'components/molecules/Loaders/LoadingLayout';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import Card from '../../../components/molecules/Card';
import { excerpt } from '../../../helpers/text/excerpt';
import useStyle from './FormationRessources.style';
import { getFormationCardLinks } from '../../../helpers/transformApiResponse/formations';
import { BackButton } from 'components/molecules/Buttons/BackButton';

export const FormationRessources = () => {
  const { id } = useParams<{ id: string }>();
  const classes = useStyle();

  const { data, loading, error } = useQuery<FindFormationByTypeIdQuery>(
    QUERY_FORMATIONS_BY_TYPE,
    {
      variables: { id }
    }
  );

  if (loading) return <LoadingLayout />;
  if (error)
    return (
      <ErrorContainer
        detailErr={
          new ApolloError({
            extraInfo: error,
            errorMessage: 'error query FindFormationByTypeIdQuery'
          })
        }
        text="error query FindFormationByTypeIdQuery"
      />
    );

  return (
    <>
      <BackButton text="Retour aux thèmes" />
      <div className={classes.cardContainer}>
        {data.findFormationByTypeId.map((formation, index) => {
          const cardLinks = getFormationCardLinks(formation);
          return (
            <div className={classes.card} key={index}>
              <Card
                key={index}
                title={formation.name}
                subTitle={formation.subtitle}
                desc={excerpt(formation.desc, 140)}
                links={cardLinks}
              />
            </div>
          );
        })}
      </div>
    </>
  );
};
